<template>
	<div v-if="!yes" class="sub-values inline">
		<div class="sub-value">
			<div class="label">{{ label }}</div>
		</div>
	</div>
	<SelectedItems
		v-else
		:characteristic-items="meta.parking"
		:characteristic-type="meta.parkingType"
		:selected="data.items"
		flat
		class="inline"
	/>
</template>

<script>
import {getLabel, TYPE_YES} from "@/helper/application/Parking";
import SelectedItems from "@/vue/characteristic/SelectedItems";
import {mapState} from "vuex";

export default {
	components: {SelectedItems},

	props: {
		data: {
			type: Object,
			required: true,
		},
	},

	computed: {
		...mapState('meta', ['meta']),
		yes ()
		{
			return this.data.type === TYPE_YES;
		},
		label ()
		{
			return getLabel(this.data.type);
		}
	}
}
</script>
